// features/payment/currentGateway.ts

import { razorpayGateway } from "./razorpay/razorpayGateway";
import { PaymentGatewayAdapter } from "./razorpay/razorpayType";

export const currentGateway: PaymentGatewayAdapter = razorpayGateway;

//  future me change karna ho:
// import { someOtherPgGateway } from "./someOtherPgGateway";
// export const currentGateway: PaymentGatewayAdapter = someOtherPgGateway;
